import { Skeleton } from "../general/skeleton";

// 0024/0025: loading placeholder matching the spacious page layout — a roomy row of KPI tiles
// + a large chart block + a table block.
const AnalyticsSkeleton = () => (
  <div className="analyticsSkeleton">
    <div className="analyticsSkeletonKpis">
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={100} />
      ))}
    </div>
    <Skeleton variant="rounded" height={360} />
    <Skeleton variant="rounded" height={220} />
  </div>
);

export default AnalyticsSkeleton;
